var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBckPetromin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0548 16.888C13.4264 16.5165 13.4264 15.914 13.0548 15.5425L8.4947 10.9824L13.0548 6.42223C13.4264 6.05067 13.4264 5.44826 13.0548 5.0767C12.6833 4.70514 12.0809 4.70514 11.7093 5.0767L7.14917 9.63682C6.40605 10.3799 6.40605 11.5848 7.14917 12.3279L11.7093 16.888C12.0809 17.2596 12.6833 17.2596 13.0548 16.888Z",
    fill: "#DC334E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBckPetromin);
export default __webpack_public_path__ + "static/media/arrow-bck-petromin.b407be5c60c101620a23775bb1dda459.svg";
export { ForwardRef as ReactComponent };